import React, { FC, useRef, useState } from 'react';
import { useField } from 'formik';
import { FieldConfig } from 'formik/dist/Field';
import { DropdownList } from 'react-widgets';
import { Tooltip } from 'reactstrap';
import { useClickOutside } from 'hooks/useClickOutside';

import stylesModal from '../../../components/modal.module.scss';
import styles from '../Formik.module.scss';

type FormikDropdownListT = {
  className: string;
  errorClassName?: string;
  label?: string;
  placeholder?: string;
  data: string[] | number[];
  disabled?: boolean;
  onSubmit?: () => void;
  setCurrentlyEditing?: (value: string) => void;
  dropUp?: boolean;
} & FieldConfig;

const FormikDropdownList: FC<FormikDropdownListT> = ({
  className,
  errorClassName,
  label,
  onSubmit,
  setCurrentlyEditing,
  ...props
}) => {
  const [field, meta, helpers] = useField(props);
  const { error, touched } = meta;

  const elementRef = useRef(null);
  const [openTooltip, setOpenTooltip] = useState(false);

  if (onSubmit && setCurrentlyEditing) {
    const handleSubmit = () => {
      if (field.value !== meta.initialValue) {
        onSubmit();
      }
      setCurrentlyEditing('');
    };

    useClickOutside(elementRef, handleSubmit);
  }

  return (
    <div
      className={className}
      style={{ position: 'relative' }}
      ref={elementRef}
      onMouseEnter={() => setOpenTooltip(true)}
      onMouseLeave={() => setOpenTooltip(false)}
    >
      {label && <p>{label}</p>}
      <DropdownList
        {...props}
        {...field}
        onChange={helpers.setValue}
        containerClassName={error && touched ? (errorClassName ? errorClassName : stylesModal.fieldError) : ''}
      />

      {error && touched ? (
        errorClassName ? (
          <Tooltip placement="bottom" isOpen={openTooltip} target={elementRef}>
            <div>{error}</div>
          </Tooltip>
        ) : (
          <div className={styles.dropdownError}>{error}</div>
        )
      ) : null}
    </div>
  );
};

export default FormikDropdownList;
